module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/braunsheitmann/ortho-field-config-translation.json
// module id = 1229
// module chunks = 0